import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { UserContextService } from '../context/user.context.service';
import { CommonUtil } from '../util/common.util';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    private readonly _router = inject(Router);
    private readonly _userContextService = inject(UserContextService);
    private readonly _dialogRef = inject(MatDialog);

    intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        return next.handle(req).pipe(
            catchError((error: HttpErrorResponse) => {
                CommonUtil.hideAppLoader();
                if (error.status === 401 && this._router.url !== '/reset-password?verify=true') {
                    this._userContextService.clear();
                    this._dialogRef.closeAll();
                    this._router.navigate(['login']);
                }

                return throwError(() => error);
            })
        );
    }
}
